import React from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import AppBar from "@mui/material/AppBar";
import { logout } from "../../services/auth/authentication";
import { useNavigate } from "react-router-dom";
import EnvManager from "../../config/envManager";
const drawerWidth = 240;

export default function NavBar(props) {

  let navigate = useNavigate();

  const handleLogout = async () => {
    sessionStorage.clear();
    EnvManager.SKIP_AUTH ? document.cookie = "session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;" : await logout();
    navigate('/login');
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        top: 0,
        bottom:'auto'
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={props.toggleDrawer}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Demo App - Auth Service
        </Typography>
        <Button color="inherit" edge="end" onClick={handleLogout}>
          <LogoutIcon/> Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
}
